import { Suspense } from "react";
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import CookieBanner from "./components/feature/CookieBanner";

function PageFallback() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background-50">
      <div className="w-10 h-10 border-4 border-primary-200 border-t-primary-500 rounded-full animate-spin" />
    </div>
  );
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <Suspense fallback={<PageFallback />}>
          <AppRoutes />
          <CookieBanner />
        </Suspense>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;